ui.form = function(){
	//Comprueba que el elemento pasado es de tipo form
	function checkForm(jq){
		if(!jq.is("form"))
			throw "El elemento jQuery debe ser form";
	}

	//Lanza la función pasada cuando cambia algún valor del formulario
	function cambioValores(jqForm,funcionCambio){
		checkForm(jqForm);
		var fChange = function(){
			funcionCambio();
		};
		jqForm.find(".campo").cambioValor(fChange);
		return jqForm;
	}

	//Obtiene los valores del formulario pasado en un objeto con valores nombreCampo=valorCampo
	function obtenerValores(jqForm){
		checkForm(jqForm);
		//quitamos los formularios anidados para no extraerlos
		var aparte = $("<div />");
		//almacenamos en todos los formularios y listados con formularios vinculados referencia al padre y hermano previo
		var jqSacar = jqForm.find(".formulario,.listadoFormV");
		jqSacar.each(
			function(){
				$(this).data("padre",$(this).parent());
				$(this).data("prev",$(this).prev());
			}
		);
		//sacamos todos los formularios anidados
		aparte.append(jqSacar);

		var valores = jqForm.serializeArray();
		var datosForm = {};
		for(var i=0;i<valores.length;i++){
			var nom = valores[i].name;
			var val = nbf.parseJSON(valores[i].value);
			if(nom.substring(nom.length-2)=="[]"){
				var k = nom.substring(0,nom.length-2);
				if(!datosForm[k])
					datosForm[k] = [];
				datosForm[k].push(val);
			}else
				datosForm[nom] = val;
		}

		//restablecemos formularios anidados
		aparte.find(".formulario,.listadoFormV").each(
			function(){
				var f = $(this);
				if(f.data("prev").size()>0)
					f.data("prev").after(f);
				else
					f.data("padre").prepend(f);
			}
		);

		return datosForm;
	}

	//Muestra los mensajes pasados en el formulario
	function mostrarMensajes(jqForm,mensajes,esError){
		checkForm(jqForm);
		var jqMensajes = jqForm.find(".mensajes:first");
		jqMensajes.empty();
		if(mensajes.length>0){
			var btnCerrar = $("<a />").attr("href","#");
			btnCerrar.html(i18next ? i18next.t('NBF_FORMULARIO_CERRAR_MENSAJES') : '<?php return txt("NBF_FORMULARIO_CERRAR_MENSAJES"); ?>');// TODO: Eliminar php cuando todos los 3.5 estén con webpack
			btnCerrar.attr("title",btnCerrar.html());
			btnCerrar.click(
				function(ev){
					ev.preventDefault();
					mostrarMensajes(jqForm,[],esError);
				}
			);
			var jqL = $("<div />").addClass(esError?"error":"info");
			jqL.append(btnCerrar);
			var jqLista = $("<ul />");
			for(var i=0;i<mensajes.length;i++)
				jqLista.append("<li>"+mensajes[i]+"</li>");
			jqL.append(jqLista);
			jqMensajes.append(jqL);
			jqForm.addClass("formularioMensajesOn");
		}else
			jqForm.removeClass("formularioMensajesOn");
	}

	//Activa/desactiva el error para el campo pasado
	function activarErrorCampo(jqCampo,listaErrores){
		jqCampo.find(".error").remove();
		var jqFs = jqCampo.closest(".fsP");
		if(listaErrores.length>0){
			jqCampo.addClass("campoError");
			jqCampo.append("<span class='error'>"+listaErrores.join("<br />")+"</span>");
		}else
			jqCampo.removeClass("campoError");
		var numErrores = jqFs.find(".campoError").size();
		if(numErrores>0)
			jqFs.addClass("fsError").attr("data-num-err",numErrores);
		else
			jqFs.removeClass("fsError").removeAttr("data-num-err");
	}

	//Aplica la respuesta de validación pasada al formulario
	function aplicarRespuestaValidacion(jqForm,validacion){
		checkForm(jqForm);
		if(validacion && validacion.validacion) //compatibilidad por si validacion es de tipo \nbf\Respuesta
			validacion = validacion.validacion;

		var errores = [];
		if(validacion && validacion.campos && validacion.campos.length>0){
			for(var i=0;i<validacion.campos.length;i++){
				var jqCampo = jqForm.find("[name="+validacion.campos[i].campo+"]:first").closest(".campo");
				var err = [];
				var info = validacion.campos[i].info;
				for(var j=0;j<info.length;j++){
					err.push(info[j].errContextual?info[j].errContextual:info[j].err);
					errores.push(info[j].err);
				}
				activarErrorCampo(jqCampo,err);
			}
		}
		if(validacion.general && validacion.general.length>0){
			for(var i=0;i<validacion.general.length;i++)
				errores.push(validacion.general[i]);
		}
		mostrarMensajes(jqForm,errores,true);
	}

	//Valida un campo en base a sus propiedades
	function validarCampo(jqCampo,jqInput,esKeypress){
		var validacion = nbf.parseJSON(jqCampo.attr("data-val"));
		var val = jqInput.val();
		var err = [];
		if(!esKeypress){ //regexp no se chequea en keypress
			if(validacion.regexp){
				if(val && val.length>0){ //las regexp no se validan en keypress hasta que no termina (blur)
					var str = validacion.regexp.regexp.replace(/^@/,"").replace(/@([a-z]+)?$/,"");
					var regexp = new RegExp(str);
					if(!regexp.test(val))
						err.push(validacion.regexp.err);
				}
			}
		}
		if(validacion.callback){
			if(val && val.length>0){
				var paramsAdic = validacion.callback.paramsAdic;
				var params = [];
				if(paramsAdic && paramsAdic.length>0)
					params = paramsAdic;
				params.splice(0,0,val);
				var respuesta = nbf.ejecutarSync(validacion.callback.func,params);
				if(respuesta.status!="ok")
					err.push(respuesta.mensajes?respuesta.mensajes[0]:respuesta);
			}
		}
		if(validacion.longitud){
			if(val && val.length>0){
				if(val.length>validacion.longitud.max)
					err.push(validacion.longitud.err);
			}
		}
		if(validacion.rango){
			if(val && val.length>0){
				if(val<validacion.rango.min || val>validacion.rango.max)
					err.push(validacion.rango.err);
			}
		}

		activarErrorCampo(jqCampo,err);
	}

	//Determina si el formulario pasado ha sido modificado
	function datosModificados(jqForm){
		checkForm(jqForm);
		return (nbf.toJSON(jqForm.data("datosInicio"))!=nbf.toJSON(obtenerValores(jqForm)));
	}

	//Habilita/Deshabilita un campo
	function deshabilitar(jq,deshab){
		jq.each(
			function(){
				var jqI = $(this);
				if(!jqI.hasClass("campo")){
					if(jqI.closest(".campo").size()>0)
						jqI = jqI.closest(".campo");
					else
						jqI = jqI.find(".campo");
				}
				if(jqI.size()>0){
					if(deshab){
						jqI.addClass("campoDeshabilitado").find("input,select,textarea").attr("disabled","disabled");
						if(jqI.hasClass("campoSelector")){
							var sel = nbf.selector.obtener(jqI.find(".selectorBloque"));
							sel.deshabilitar(true);
						}
					}else{
						jqI.removeClass("campoDeshabilitado").find("input,select,textarea").removeAttr("disabled");
						if(jqI.hasClass("campoSelector")){
							var sel = nbf.selector.obtener(jqI.find(".selectorBloque"));
							sel.deshabilitar(false);
						}
					}
				}
			}
		);
	}

	//Selecciona la tab pasada en el formulario
	function seleccionarTab(jqForm,iTab,incluirHash){
		var tab = jqForm.find(".tabs .tab"+iTab);
		var fs = jqForm.find(".fsTab"+iTab);
		var funcOk = function(){
			if(incluirHash){
				var tabHash = jqForm.attr("data-tabHash");
				window.location.hash = "#"+tabHash+iTab;
			}
			tab.addClass("tabSel").siblings().removeClass("tabSel");
			jqForm.removeClass("formularioTabSel"+jqForm.data("tabSel")).addClass("formularioTabSel"+iTab);
			jqForm.data("tabSel",iTab);
			fs.addClass("fsTabSel").siblings().removeClass("fsTabSel");
		};

		var funcContenido = fs.attr("data-funccontenido");
		if(funcContenido && !fs.data("contenidoCargado")){ //debemos solicitar la carga por ajax
			jqForm.actualizarTab(
				iTab,
				function(){
					fs.data("contenidoCargado",true);
					funcOk();
				}
			);
		}else
			funcOk();
	}

	//Actualiza el tab pasado
	function actualizarTab(jqForm,iTab,funcionOk){
		var fs = jqForm.find(".fsTab"+iTab);
		var funcContenido = fs.attr("data-funccontenido");
		if(funcContenido){
			nbf.ejecutar(
				funcContenido,
				[jqForm.obtenerValores()],
				function(respuesta){
					if(respuesta.status=="ok"){
						var elem = $(respuesta.html);
						if(elem.hasClass("formulario"))
							elem = elem.find(".fs:first");
						fs.html(elem.html());
						//inicializamos el fieldset
						ui.init(fs);
						if(funcionOk)
							funcionOk();
					}else
						ui.popup.crearAlertaRespuesta(respuesta);
				}
			);
		}
	}

	//asocia el evento de cambio de valor sobre el campo pasado
	function cambioValor(jqCampo,funcionCambio){
		jqCampo.on(
			"cambioValor",
			function(ev){
				//lo lanzamos para que múltiples llamadas a cambio valor sólo originen una llamada a funcionCambio (para función asignarValores por ejemplo)
				nbf.lanzar(500,function(){funcionCambio(ev.valor);},funcionCambio);
			}
		);
		return jqCampo;
	}

	//asigna el valor pasado al campo
	function asignarValor(jqCampo,valor){
		if(jqCampo.data("asignarValor")) //si el campo lo define en su data lo lanzamos
			jqCampo.data("asignarValor")(valor);
		else{ //campos de texto generales
			jqCampo.find("input[type!=hidden]").val(valor);
			jqCampo.find("textarea").val(valor);
		}
		return jqCampo;
	}

	//asigna los valores pasados al formulario
	function asignarValores(jqForm,valores){
		checkForm(jqForm);
		for(var nom in valores)
			jqForm.find(".campoNom"+nom.charAt(0).toUpperCase()+nom.substring(1)).asignarValor(valores[nom]);
		return jqForm;
	}

	//lanza el evento de cambio de valor
	function lanzarCambioValor(jqCampo,valor){
		var event = jQuery.Event("cambioValor");
		event.valor = valor;
		jqCampo.trigger(event);
	}

	ui.ready(
		"form.formulario", //debemos forzar que sea <form> para asegurarnos que obtenerValores funciona
		function(jq){
			jq.data("datosInicio",jq.obtenerValores());

			if(jq.hasClass("formularioTabs")){
				//pestañas
				//seleccionamos la pestaña correspondiente si tiene tabHash
				var tabHash = jq.attr("data-tabHash");
				var tabSel = false;
				if(window.location.hash && window.location.hash.indexOf("#"+tabHash)==0){
					var iTab = window.location.hash.replace(new RegExp("#"+tabHash),"");
					if(!isNaN(iTab)){
						jq.seleccionarTab(iTab);
						tabSel = true;
					}
				}
				//no se ha seleccionado ningún tab y la primera carga su contenido via ajax
				if(!tabSel && jq.find(".fsTab1").attr("data-funccontenido"))
					jq.seleccionarTab(1);

				//click sobre pestañas
				jq.find(".tabs a").click(
					function(ev){
						ev.preventDefault();
						var tab = $(this).closest(".tab");
						var iTab = nbf.extraerDatos(tab);
						tab.closest(".formulario").seleccionarTab(iTab,tabHash && tabHash.length>0);
					}
				);
			}

			jq.find(".fsColapsable").each(
				function(){
					var activo = false;
					$(this).find("input,select").each(
						function(){
							if($(this).val()!="")
								activo = true;
						}
					);

					var lnk = $(this).find(".tit .i");
					lnk.click(
						function(ev){
							ev.preventDefault();
							$(this).closest(".fs").toggleClass("fsColapsableOn");
						}
					);
					if(activo)
						lnk.click();
				}
			);
		}
	);

	ui.ready(
		".campoValidable",
		function(jq){
			var validacion = jq.attr("data-val");
			if(validacion){
				if(jq.hasClass("campoSelector")){
					var input = jq.find("input[type=hidden]:first");
					var sel = nbf.selector.obtener(input);
					if(sel){
						sel.change(
							function(){
								validarCampo(jq,input);
							}
						);
					}
				}else{
					var input = jq.find("input[type!=hidden]:first,>textarea:first");
					if(input.size()>0){
						switch(input.attr("type")){
							case "radio":
								input.click(
									function(){
										validarCampo(jq,input);
									}
								);
							break;
							default:
								var tt = null;
								input.keyup(
									function(ev){
										tt = nbf.lanzar(
											500,
											function(){
												validarCampo(jq,input,true);
											}
										);
									}
								).blur(
									function(){
										if(tt){ //si hay un lanzar activo lo cancelamos
											clearTimeout(tt);
											tt = null;
										}
										validarCampo(jq,input);
									}
								);
						}
					}else{
						var select = jq.find("select:first");
						if(select.size()>0){
							select.change(
								function(ev){
									validarCampo(jq,select);
								}
							);
						}
					}
				}
			}
		}
	);

	//evento cambioValor en campos generales
	ui.ready(
		".campo:not(.campoSoloLectura):not(.campoSelector):not(.campoChecks):not(.campoCheck):not(.campoRadio):not(.campoSelect):not(.campoRango)",
		function(jq){

			var fAsignarV = function(){
				$(this).data("valAnt",$(this).val());
			};

			jq.find("input[type=text],input[type=password],textarea").focus(
				fAsignarV
			).blur(
				function(ev){
					var i = $(this);
					if(i.data("valAnt")!=i.val()){
						nbf.lanzar(
							500,
							function(){
								lanzarCambioValor(jq,i.val());
							}
						);
					}
				}
			).each(
				fAsignarV
			);
		}
	);

	ui.ready(
		".campoSelector",
		function(jq){
			jq.data(
				"asignarValor",
				function(valor){
					var sel = nbf.selector.obtener(jq.find(".selectorVal"));
					sel.asignarValor(valor);
				}
			);

			nbf.selector.obtener(jq.find(".selectorBloque")).change(
				function(val){
					lanzarCambioValor(jq,val);
				}
			);
		}
	);

	ui.ready(
		".campoChecks,.campoCheck,.campoRadio",
		function(jq){
			var valHidden = jq.hasClass("campoChecks");

			//función para asignar valor
			jq.data(
				"asignarValor",
				function(valor){
					var input = jq.find(".elem input");
					if(valHidden){
						input.each(
							function(){
								this.checked = $.inArray($(this).val(),valor);
								jq.find('input[type="hidden"]').val(nbf.toJSON(valor));
							}
						);
					}else
						input.get(0).checked = (valor==1);
				}
			);

			var actualizaClassElem = function(input){
				var elem = $(input).closest(".elem");
				if(input.checked){
					elem.removeClass("elemOff").addClass("elemOn");
					if(input.type=="radio")
						elem.siblings().removeClass("elemOn").addClass("elemOff");
				}else
					elem.removeClass("elemOn").addClass("elemOff");
			};

			jq.find(".elem input").click(
				function(){
					var valorCampo = this.checked;
					if(valHidden){ //actualización de valor hidden
						var contenedor = $(this).closest(".checks");
						var valores = [];
						contenedor.find(".elem input").each(
							function(){
								if(this.checked)
									valores.push(this.value);
					        }
					    );
					    valorCampo = contenedor.find('input[type="hidden"]').val(nbf.toJSON(valores)).val();
					}
					actualizaClassElem(this);
					lanzarCambioValor(jq,valorCampo);
				}
			).focus(
				function(){
					$(this).closest(".elem").addClass("elemFocus");
				}
			).blur(
				function(){
					$(this).closest(".elem").removeClass("elemFocus");
				}
			).each( //inicialización
				function(){
					actualizaClassElem(this);
				}
			);
		}
	);

	ui.ready(
		".campoSelect:not(.campoSoloLectura)",
		function(jq){
			//función para asignar valor
			jq.data(
				"asignarValor",
				function(valor){
					jq.find("select option[value="+valor+"]").attr('selected',true);
					jq.find("select").change();
				}
			);
			jq.find("select").change(
				function(){
					lanzarCambioValor(jq,$(this).val());
				}
			);
		}
	);

	ui.ready(
		".campoRango:not(.campoSoloLectura)",
		function(jq){
			var jqSlider = jq.find(".slider");
			var jqVal = jq.find(".rangoVal");
			var jqSel = jqSlider.find(".seleccion");
			var jqRan = jq.find(".rangos");
			var etFormato = nbf.parseJSON(jqRan.attr("data-formato"));
			var jqBody = $("body");
			var selw;
			var selposL;
			var selposR;
			var vLista = null;
			if(jqRan.attr("data-vl"))
				vLista = nbf.parseJSON(jqRan.attr("data-vl"));
			var vMax = jqRan.attr("data-vMax");
			var vMin = jqRan.attr("data-vMin");

			//calcula dimensiones y posición de slider
			var calcularDim = function(){
				selw = jqSlider.width();
				selposL = jqSlider.offset().left;
				selposR = jqSlider.offset().left+selw;
			};

			var posPorc = function(esMin){
				calcularDim();
				var valCss = jqSel.css(esMin?"left":"right");
				if(valCss.indexOf("px")>-1)
					return valCss.replace(/px/,"")*1.0/selw*100;
				else if(valCss.indexOf("%")>-1)
					return valCss.replace(/%/,"")*1.0;
			};

			//posición de elemento en la lista de valores
			var posVLista = function(val){
				var i=0;
				for(var k in vLista){
					if(k==val)
						return i;
					i++;
				}
				return null;
			};

			//posición de elemento en la lista de valores
			var valVLista = function(pos){
				var i=0;
				for(var k in vLista){
					if(i==pos)
						return k;
					i++;
				}
				return null;
			};

			//cambiamos valor max y min a las posiciones en la lista de valores
			if(vLista){
				vMax = posVLista(vMax);
				vMin = posVLista(vMin);
			}

			var actualizar = function(esMin){
				var pos = posPorc(esMin);
				if(!esMin)
					var pos = 100-pos;
				var inc = jqRan.attr("data-inc");

				var val = nbf.parseJSON(jqVal.val());
				//si hay lista: cambiamos val a las posiciones en la lista de los elementos
				if(vLista)
					val = [posVLista(val[0]),posVLista(val[1])];

				val[esMin?0:1] = vMin*1.0+(pos/100.0*(vMax-vMin));

				var sonIguales = (val[1]-val[0]<inc/2);

				//redondeo al incremento más cercano
				if(esMin)
					val[0] = Math.floor(val[0]/inc)*inc;
				else
					val[1] = Math.ceil(val[1]/inc)*inc;
				if(val[0]>val[1])
					val[0] = val[1];

				//en listas de valores, permitimos igualar valor
				if(vLista && sonIguales){
					if(vMax-val[1]<val[0]-vMin) //más cerca del max
						val[0] = val[1];
					else //más cerca del min
						val[1] = val[0];
				}

				//convertimos a keys de lista de nuevo
				if(vLista)
					val = [valVLista(val[0]),valVLista(val[1])];

				jqVal.val(nbf.toJSON(val));
				//lanzamos el cambio de valor dentro de 300ms para no acumular peticiones
				nbf.lanzar(
					300,
					function(){
						lanzarCambioValor(jq,val);
					}
				);

				var format = function(v){
					if(vLista) //lista de valores
						return vLista[v];
					else{
						v = v.toFixed(etFormato.posDec);
						var p = v.toString().split(".");
						if(p[0]>1000){
							var r = p[0]%1000;
							r = (r<10?"00":(r<100?"0":""))+r;
							p[0] = Math.floor(p[0]/1000)+etFormato.carMil+r;
						}
						v = p[0];
						if(p[1]) //si tiene parte decimal
							v += etFormato.carDec+p[1];
						return etFormato.pref+v+etFormato.suf;
					}
				};

				if(esMin)
					jqRan.find(".min").html(format(val[0]));
				else
					jqRan.find(".max").html(format(val[1]));
			};

			//mueve jqC al pixel x pasado
			var moverPx = function(jqC,pos){
				calcularDim();
				if(jqC.hasClass("ctlMin")){
					var porcL = (pos-selposL)/selw*100;
					var porcR = posPorc(false);
					if(porcL<0)
						porcL = 0;
					if(porcL>100-porcR)
						porcL = 100-porcR;
					jqSel.css("left",porcL+"%");
				}else{
					var porcL = posPorc(true);
					var porcR = (selposR-pos)/selw*100;
					if(porcR<0)
						porcR = 0;
					if(porcR>100-porcL)
						porcR = 100-porcL;
					jqSel.css("right",porcR+"%");
				}
				actualizar(jqC.hasClass("ctlMin"));
			};

			//función para asignar valor
			jq.data(
				"asignarValor",
				function(valor){
					if(!$.isArray(valor))
						valor = nbf.parseJSON(valor);
					if(vLista)
						valor = [posVLista(valor[0]),posVLista(valor[1])];

					calcularDim();
					var posMin = selposL+(valor[0]-vMin)/(vMax-vMin)*selw;
					var posMax = selposL+(valor[1]-vMin)/(vMax-vMin)*selw;
					moverPx(jq.find(".ctlMin"),posMin);
					moverPx(jq.find(".ctlMax"),posMax);
				}
			);

			if(!jqBody.data("evRango")){
				jqBody.bind(
					"mouseup touchend",
					function(ev){
						$(".campoRango .ctlMove").removeClass("ctlMove");
					}
				);
				jqBody.data("evRango",true);
			}

			jqSlider.click(
				function(ev){
					if(jq.hasClass("campoDeshabilitado") || (jq.hasClass("campoRangoFMin") && jq.hasClass("campoRangoFMax")))
						return;
					var ctl = $(this).find(".ctl");
					var i = 0;
					if(ev.pageX<ctl.eq(0).offset().left){ //a la izquierda del min: cogemos min
						i = 0;
						if(jq.hasClass("campoRangoFMin")) //min fijo
							return;
					}else if(ev.pageX>ctl.eq(1).offset().left){ //a la derecha del max: cogemos max
						i = 1;
						if(jq.hasClass("campoRangoFMax")) //min fijo
							return;
					}else{ //pulsación interior: oscilamos
						$(this).data("cambio",!$(this).data("cambio"));
						i = ($(this).data("cambio")?0:1);
						if(i==0 && jq.hasClass("campoRangoFMin")) //min fijo, elegimos max
							i = 1;
						if(i==1 && jq.hasClass("campoRangoFMax")) //max fijo, elegimos min
							i = 0;
					}
					moverPx(ctl.eq(i),ev.pageX);
				}
			);

			jqSel.find(".ctl").bind(
				"mousedown touchstart mousemove touchmove",
				function(ev){
					if(jq.hasClass("campoDeshabilitado"))
						return;
					if(jq.hasClass("campoRangoFMin") && $(this).hasClass("ctlMin"))
						return;
					if(jq.hasClass("campoRangoFMax") && $(this).hasClass("ctlMax"))
						return;
					if(ev.type=="mousedown" || ev.type=="touchstart"){
						ev.stopPropagation();
						$(this).addClass("ctlMove");
					}else{
						ev.preventDefault();
						var jqC = $(this);
						if(jqC.hasClass("ctlMove")){
							if(ev.type=="touchmove")
								moverPx(jqC,ev.originalEvent.touches[0].pageX);
							else
								moverPx(jqC,ev.pageX);
						}
					}
				}
			).click(
				function(ev){
					ev.preventDefault();
					ev.stopPropagation();
				}
			);
		}
	);

	//extendemos funcionalidad jquery para formularios y campos
	jQuery.fn.extend(
		{
			"obtenerValores":function(){
				 return obtenerValores(this);
			},
			"aplicarRespuestaValidacion":function(validacion){
				 return aplicarRespuestaValidacion(this,validacion);
			},
			"mostrarMensajes":function(mensajes,esError){
				 return mostrarMensajes(this,mensajes,esError);
			},
			"datosModificados":function(){
				 return datosModificados(this);
			},
			"asignarValores":function(valores){
				 return asignarValores(this,valores);
			},
			"cambioValores":function(funcionCambio){
				 return cambioValores(this,funcionCambio);
			},
			"deshabilitar":function(deshab){
				return deshabilitar(this,deshab);
			},
			"seleccionarTab":function(iTab,incluirHash){
				return seleccionarTab(this,iTab,incluirHash);
			},
			"actualizarTab":function(iTab,funcionReady){
				return actualizarTab(this,iTab,funcionReady);
			},
			"asignarValor":function(valor){
				return asignarValor(this,valor);
			},
			"cambioValor":function(funcionCambio){
				return cambioValor(this,funcionCambio);
			}
		}
	);

	return {
		"obtenerValores":obtenerValores,
		"asignarValores":asignarValores,
		"cambioValores":cambioValores,
		"asignarValor":asignarValor,
		"cambioValor":cambioValor,
		"aplicarRespuestaValidacion":aplicarRespuestaValidacion,
		"mostrarMensajes":mostrarMensajes,
		"datosModificados":datosModificados,
		"deshabilitar":deshabilitar,
		"seleccionarTab":seleccionarTab,
		"actualizarTab":actualizarTab
	}
}();

